import { render, staticRenderFns } from "./detail-tips.vue?vue&type=template&id=bee1d118&scoped=true"
import script from "./detail-tips.vue?vue&type=script&lang=js"
export * from "./detail-tips.vue?vue&type=script&lang=js"
import style0 from "./detail-tips.vue?vue&type=style&index=0&id=bee1d118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee1d118",
  null
  
)

export default component.exports